import * as React from 'react';
import { renderAlert, renderInput, inputColorWhenError,
  inputColorWhenNoError } from './RenderCommon';
import {getUserId, sessionExpire} from './MonCompteAction';
import axios from "axios";
import {getHostApi, getRequestConfig} from "../../utils";

interface RenderFormIbanState {
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  fullName: string;
  iban: string;
  bic: string;
  pays: any[];
  dataPays: string;
  ibanArrayInput: any;
}

export default class RenderFormIban extends React.Component<Record<string, unknown>, RenderFormIbanState> {
  private ibanArrayInput: any;
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = {
      showAlert: false,
      textAlert: 'Votre IBAN a bien été inséré',
      classAlert: 'alert-success',
      fullName: '',
      iban: '',
      bic: '',
      pays: [],
      dataPays: "FR_France_27",
      ibanArrayInput: []
    };
    this.ibanArrayInput = [];
  }

  componentDidMount() {
    this._getPays();
    this._getIbanByCustomer();
  }

  /**
   *
   * @private
   */
  _getPays() {
    axios.get(`${getHostApi()}/customers/iban/pays`, getRequestConfig())
        .then((res) => {
          if (res.data) {
            this.setState({
              pays: res.data,
            }, () => {
              this._setPaysUserInSelect();
            });
          }
        }).catch((err) => {
      console.error(err);
    });
  }

  _getIbanByCustomer() {
    const url = `${getHostApi()}/customers/${getUserId()}/iban`;

    axios.get(url, getRequestConfig()).then((response) => {
      if (response.data) {
        this.setState({
          fullName: response.data.titulaire,
          iban: response.data.iban,
          bic: response.data.bic,
          ibanArrayInput: response.data.iban.match(/.{1,4}/g)
        }, () => {
        if (response.data?.iban?.length > 0) {
          document.getElementById('intituleBtn')?.classList.add('d-none');
          document.getElementById('modifierBtn')?.classList.remove('d-none');
          this.ibanArrayInput = response.data.iban.match(/.{1,4}/g);
        }});
      }
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _setPaysUserInSelect = () => {
    const paysUser = this.state.pays.filter(element => element.codePays == this.state.iban.substr(0, 2));
    if(paysUser.length > 0 && paysUser[0]['codePays'] != "FR") {
      this.setState({
        dataPays: paysUser[0]['codePays']+"_"+paysUser[0]['libelle']+"_"+paysUser[0]['longueur']
      })
    }
  }

  _resetForm  = (inserted: boolean) => {
    if (inserted) {
      document.getElementById('intituleBtn')?.classList.add('d-none');
      document.getElementById('modifierBtn')?.classList.remove('d-none');
    }
  }

  /**
   * Fonction mettant à jour le profil du client connecté
   *
   * @param {React.MouseEvent<HTMLButtonElement>} event
   * @private
   */
  _insertIban = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (this.state.iban === '' || this.state.bic === '' || this.state.fullName === '') {
      this.setState({
        showAlert: true,
        textAlert: 'Veuillez renseigner les champs obligatoires ',
        classAlert: 'alert-danger',
      });
      this._colorEmptyRequiredInput();
    } else {
      axios.post(`${getHostApi()}/customers/${getUserId()}/iban`,
          { iban: this.state.iban, bic: this.state.bic, fullName: this.state.fullName, dataPays: this.state.dataPays }
          , getRequestConfig())
          .then((response) => {
            this._colorRequiredInput();
            this.setState({
              showAlert: true,
              textAlert: 'Vos informations bancaires ont bien été insérées',
              classAlert: 'alert-success',
            });
            this._resetForm(true);
          }).catch((error) => {
            this.setState({
              showAlert: true,
              textAlert: 'Erreur à l\'insertion',
              classAlert: 'alert-danger',
            });
          });
      }
  }

  _colorEmptyRequiredInput = () => {
    this._colorRequiredInput();
    if (this.state.fullName === '') {
      inputColorWhenError('fullName');
    }
    if (this.state.iban === '') {
      inputColorWhenError('iban');
    }
    if (this.state.bic === '') {
      inputColorWhenError('bic');
    }
  }

  _colorRequiredInput = () => {
    if (this.state.fullName != '') {
      inputColorWhenNoError('fullName');
    }
    if (this.state.iban != '') {
      inputColorWhenNoError('iban');
    }
    if (this.state.bic != '') {
      inputColorWhenNoError('bic');
    }
  }

  /**
   * Fonction mettant à jour le state customer en fonction des valeurs saisies dans le formulaire
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event
   * @private
   */
  _onUpdateInput = (event: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    let value = target.value;

    const champs = ["fullName", "iban", "bic"];

    if(name === "bic" || name.includes("iban")) {
      value=value.toUpperCase()
    }

    if(name.includes("iban")) {
      const nextInput = parseInt(name.substr(15,1)) + 1;
      const next = parseInt(name.substr(15,1));
      const ibanArrayInput = this.state.ibanArrayInput;
      ibanArrayInput[next] = value;
      this.setState({...this.state, ibanArrayInput: ibanArrayInput });
      if(value.length >= 4) {
        this.ibanArrayInput[nextInput]?.focus();
      }
      this.setState({...this.state, iban: this.state.ibanArrayInput.join('').replaceAll(' ', '') });
    }

    if(name === "dataPays") {
      const nbBlocs = Math.round(parseInt(this.state.dataPays.split("_")[2]) / 4);
      const newNbBlocs = Math.round(parseInt(value.split("_")[2]) / 4);
      const ibanArrayInput = this.state.ibanArrayInput;
      if(newNbBlocs < nbBlocs) {
        for (let j=0; j < nbBlocs; j++) {
          ibanArrayInput[j] = "";
          document.getElementsByName('ibanArrayInput['+j+']')[0].setAttribute('value', ibanArrayInput[j]);
        }
        this.setState({...this.state, iban: '', ibanArrayInput: ibanArrayInput, dataPays: value});
      } else {
        this.setState({...this.state, dataPays: value});
     }
    }
    if(champs.includes(name)) {
      this.setState({...this.state, [name]: value });
    }
  }

  _onPasteInput = (event: any, nbBlocs: number) => {
    event.preventDefault();
    const text = event.clipboardData.getData("text").replaceAll(' ', '').toUpperCase();
    const ibanArrayInput = this.state.ibanArrayInput;

    let i=0;
    for (let j=0; j < nbBlocs; j++) {
      ibanArrayInput[j] = text.substr(i, 4);
      document.getElementsByName('ibanArrayInput['+j+']')[0].setAttribute('value', ibanArrayInput[j]);
      i+=4;
    }

    this.setState({...this.state, ibanArrayInput: ibanArrayInput, iban: ibanArrayInput.join('') });
  }

  _isIBANValid = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    axios.post(
        `${getHostApi()}/customers/iban/validate`,
        { iban: this.state.iban, bic: this.state.bic, fullName: this.state.fullName, dataPays: this.state.dataPays },
        getRequestConfig()).then((response) => {
          if (response.data.valid.longueur === false) {
            this.setState({
              showAlert: true,
              textAlert: 'La longueur de l\'IBAN n\'est pas correcte',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('iban');
          } else if (response.data.valid.bic === false) {
            this.setState({
              showAlert: true,
              textAlert: 'Le code BIC n\'est pas correct',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('bic');
          } else if (response.data.valid.fullName === false) {
            this.setState({
              showAlert: true,
              textAlert: 'Erreur de saisie du titulaire de compte',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('fullName');
          } else if (response.data.valid.iban === false) {
            this.setState({
              showAlert: true,
              textAlert: 'L\'IBAN saisi n\'est pas correct',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('iban');
          } else {
            this._insertIban(event);
          }
        }).catch((error) => {
          this.setState({
            showAlert: true,
            textAlert: error.response.data.message,
            classAlert: 'alert-danger',
          });
        });
  }

  render() {
    const renderPays = () => {
      const paysOptions = this.state.pays.map((elt: any) => {
        return (<option key={elt.codePays} value={elt.codePays+"_"+elt.libelle+"_"+elt.longueur}>{elt.libelle}</option>);
      });
      return (
          <div className="d-flex align-items-center mb-3">
            <label className="col-md-3 pa0 text-left">Pays du compte bancaire</label>
            <div className="col-md-6 text-left">
              <select
                      value={this.state.dataPays}
                      onChange={this._onUpdateInput} className="w100 border px-2 bg-white rounded "
                      name="dataPays">
                {paysOptions}
              </select>
            </div>
          </div>
      );
    };

    const renderFullName = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          <label className="col-md-3 pa0 text-left">Nom et Prénom du titulaire</label>
          {renderInput('text', 'fullName', this.state.fullName, this._onUpdateInput)}
        </div>
      );
    };

    const renderIban = () => {

      const InputArrayIban = () => {
        const result = [];
        const nbBlocs = Math.ceil(parseInt(this.state.dataPays.split("_")[2]) / 4);
        for (let i=0; i < nbBlocs; i++) {
          if(i == 0) {
            result.push(
                <input
                    key={i}
                    maxLength={4}
                    name={'ibanArrayInput['+i+']'}
                    ref={(input) => {
                      this.ibanArrayInput[i] = input;
                    }}
                    value={this.state.ibanArrayInput[i]}
                    onChange={(event) => this._onUpdateInput(event)}
                    onPaste={(event) => {this._onPasteInput(event, nbBlocs)} }
                    style={{width: 50, marginRight: 5, marginTop: 5}}
                />
            )
          } else {
            result.push(
                <input
                    key={i}
                    maxLength={4}
                    name={'ibanArrayInput['+i+']'}
                    ref={(input) => {
                      this.ibanArrayInput[i] = input;
                    }}
                    value={this.state.ibanArrayInput[i]}
                    onChange={(event) => this._onUpdateInput(event)}
                    style={{width: 50, marginRight: 5, marginTop: 5}}
                />
            )
          }

        }
        return result;
      }

      return (
          <>
            <div className="d-flex align-items-center mb-3 flexWrapIban">
              <label className="col-md-3 pa0 text-left">Numéro IBAN</label>
              <div className={"d-flex col-md-9"}>
                {InputArrayIban()}
              </div>
            </div>
          </>
      );
    };

    const renderBic = () => {
      return (
          <>
            <div className="d-flex align-items-center mb-2">
              <label className="col-md-3 pa0 text-left">Code BIC/SWIFT</label>
              {renderInput('text', 'bic', this.state.bic, this._onUpdateInput)}
            </div>
            <div className="d-flex mb-4">
              <label className="col-md-3 pa0 text-left"/>
              <span className="col-md-6 text-left lightgrey">(Bank Identification Code)</span>
            </div>
          </>
      );
    };

    const renderForm = () => {
      return (
        <div className="mb-4 divFormProfil">
          {renderPays()}
          {renderFullName()}
          {renderIban()}
          {renderBic()}
        </div>
      );
    };

    const renderFormIBAN = () => {
      return (
          <div className="formIban p-3 text-center border mx-auto">
              <form>
                {renderForm()}
                {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
                <button onClick={this._isIBANValid}
                    className="profilButton bg-blue border-0 py-1 px-3 white w-75 reset-button buttonPrimary">
                  <span id="intituleBtn">Valider</span>
                  <span className="d-none" id="modifierBtn">Modifier</span>
                </button>
              </form>
          </div>
      );
    };
    return (
        <>
          {renderFormIBAN()}
        </>
    );
  }
}
